














import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Lokasi extends Vue {
  @Prop() setLokasi: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  // lokasi = null;

  // @Watch("lokasi")
  // changeLokasi(val) {
  //   this.$emit("lokasi", val);
  // }

  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setLokasi == "" || this.setLokasi == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setLokasi")
  valLokasi(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("lokasi", val);
    this.setLokasi = val;
  }
}
